import { recapTimeline } from "@/mocks/gossip";

const stageColor: Record<string, string> = {
  开盘: "bg-secondary-500",
  发酵: "bg-accent-500",
  中场: "bg-primary-500",
  收尾: "bg-foreground-700",
};

export default function Recap() {
  return (
    <section id="recap" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="flex items-center justify-center gap-2 text-sm font-semibold text-primary-600">
            <i className="ri-moon-line"></i> 瓜田晚间汇总 · 收尾盘点
          </p>
          <h2 className="serif-title mt-2 text-3xl font-black text-foreground-950 md:text-5xl">
            全瓜复盘：今天从早到晚怎么演
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-600">
            跟着时间线走一遍今日战况——开盘、发酵、中场到收尾，错过直播也能完整补课。
          </p>
        </div>

        <div className="relative mt-14">
          <div className="absolute bottom-4 left-4 top-4 w-px bg-background-300 md:left-1/2"></div>
          <div className="flex flex-col gap-10">
            {recapTimeline.map((node, i) => {
              const left = i % 2 === 0;
              return (
                <div key={node.time} className={`relative flex flex-col md:flex-row ${left ? "md:justify-start" : "md:justify-end"}`}>
                  <div className="absolute left-4 top-6 z-10 hidden -translate-x-1/2 md:left-1/2 md:block">
                    <span className={`flex h-4 w-4 rounded-full border-4 border-background-100 ${stageColor[node.stage]}`}></span>
                  </div>

                  <div className={`ml-10 w-auto md:ml-0 md:w-[calc(50%-3rem)] ${left ? "" : ""}`}>
                    <article className="rounded-2xl border border-background-200 bg-background-50 p-5 shadow-card md:p-6">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold text-background-50 ${stageColor[node.stage]}`}>
                          {node.stage}
                        </span>
                        <span className="flex items-center gap-1 text-xs font-semibold text-foreground-500">
                          <i className="ri-time-line"></i> {node.time}
                        </span>
                      </div>
                      <h3 className="serif-title mt-3 text-lg font-bold text-foreground-900 md:text-xl">
                        {node.title}
                      </h3>
                      <ul className="mt-3 space-y-2">
                        {node.points.map((p) => (
                          <li key={p} className="flex items-start gap-2 text-sm leading-relaxed text-foreground-600">
                            <i className="ri-checkbox-circle-line mt-0.5 shrink-0 text-secondary-500"></i>
                            {p}
                          </li>
                        ))}
                      </ul>
                      <p className="mt-4 flex items-start gap-2 rounded-xl bg-accent-50 px-3 py-2.5 text-sm leading-relaxed text-foreground-700">
                        <i className="ri-question-answer-line mt-0.5 shrink-0 text-accent-600"></i>
                        <span><strong className="text-accent-800">小编补一句：</strong>{node.note}</span>
                      </p>
                    </article>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="mt-12 text-center">
          <a
            href="#hot"
            onClick={(e) => { e.preventDefault(); document.querySelector("#hot")?.scrollIntoView({ behavior: "smooth" }); }}
            className="inline-flex items-center gap-2 rounded-full border border-foreground-200 bg-background-50 px-7 py-3 text-sm font-semibold text-foreground-800 whitespace-nowrap transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer"
          >
            返回热议榜
            <i className="ri-arrow-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}